<template>
  <div>
    <div class="mb-4">
      <button
        class="btn btn-primary"
        @click.prevent="createNewTask"
      >
        <i class="fa fa-fw fa-plus mr-1"></i>
        New Task
      </button>
    </div>
    <div class="nav flex-column h5 font-weight-normal mb-0">
      <!--
      <div class="nav-item mb-3">
        <router-link
          to="/tasks/inbox"
          class="nav-link text-body text-decoration-none"
        >
          Inbox
        </router-link>
      </div>
      -->
      <div class="nav-item mb-1">
        <router-link
          :to="{name: 'tasks.today', params: { userId }}"
          class="nav-link text-decoration-none"
        >
          Today
        </router-link>
      </div>
      <div class="nav-item mb-1">
        <router-link
          :to="{name: 'tasks.upcoming', params: { userId }}"
          class="nav-link text-decoration-none"
        >
          Upcoming
        </router-link>
      </div>
      <div class="nav-item mb-1">
        <router-link
          :to="{name: 'tasks.anytime', params: { userId }}"
          class="nav-link text-decoration-none"
        >
          Anytime
        </router-link>
      </div>
      <!--
      <div class="nav-item mb-3">
        <router-link
          to="/tasks/someday"
          class="nav-link text-body text-decoration-none"
        >
          Someday
        </router-link>
      </div>
      -->
      <div class="nav-item mb-1">
        <router-link
          :to="{name: 'tasks.complete', params: { userId }}"
          class="nav-link text-decoration-none"
        >
          Complete
        </router-link>
      </div>
      <div class="my-0 small">&nbsp;</div>
      <div
        v-for="filter in taskFilters"
        :key="`taskFilter_${filter.text}`"
        class="nav-item"
      >
        <a
          :class="[
            'nav-link small text-nowrap',
            {
              'font-weight-bold text-primary': filter.active,
              'text-body': !filter.active
            }
          ]"
          href="#"
          @click.prevent="search(filter.text)"
        >
          #{{ filter.text }}
        </a>
      </div>
      <!--
      <div class="nav-item mb-1">
        <router-link
          :to="{name: 'tasks.source', params: { source: 'Sphere of Influence', userId }}"
          class="nav-link text-body text-decoration-none small"
        >
          Sphere of Influence
        </router-link>
      </div>
      -->
    </div>
  </div>
</template>

<style scoped>
.nav-link {
  color: #111;
}
.router-link-active {
  font-weight: bold;
  color: #3498DB;
}
</style>

<script>
import $ from 'jquery'
import { map } from 'lodash'

export default {
  props: {
    userId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    taskFilters () {
      let query = this.$route.query.q || ''

      return map(window._leadSources || [], (filter) => {
        return {
          'text': filter,
          'active': query.indexOf(this.makeTag(filter)) > -1
        }
      })
    }
  },
  methods: {
    createNewTask () {
      $(window).trigger('createNewTask.requested')
    },
    makeTag (filter) {
      return '#"' + filter.replaceAll('"', '\\"') + '"'
    },
    search (filter) {
      let location = {
        name: 'tasks.search',
        params: {
          userId: this.$route.params.userId
        },
        query: {
          q: this.makeTag(filter)
        }
      }
      this.$router.push(location)
    }
  }
}
</script>
